export const TOKEN_RESPONSE = 'tokenResponse'
